import PropTypes from 'prop-types';
import React, { useEffect } from 'react';
import { useSpring, animated } from '@react-spring/web';
import styled from 'styled-components';
import Sticker from 'react-stickyfill';
import { withRouter } from 'utils/withRouter';
import { OnDesktopAndTablet, OnPhone } from 'ui/media';
import SearchBar from 'search/containers/search-bar-container';
import PermissionCheck from 'common/features/permission-check';
import Banner from 'common/banner/banner';
import { useDispatch, useSelector } from 'react-redux';
import SystemMessageButton from '../../system-message/containers/system-message-button-container';
import UserProfileButton from './user-profile-button';
import HeaderButton from './header-button';
import UploadXmlButton from '../../upload-xml/containers/upload-xml-button-container';
import {
  openAnnouncementsSidepanel,
} from '../../../settings/containers/announcements/announcements-actions';

const Header = styled(animated.div)`
  display: flex;
  justify-content: space-between;
  align-items: center;
  background-color: ${p => p.theme.colors.theme};
  height: ${p => p.theme.header.height};
  position: sticky;
  z-index: 125;
  top: 0;
`;

const LogoContainer = styled.div`
  margin-left: 11px;
  width: 150px;
  display: flex;
  justify-content: center;
`;

const Logo = styled.div`
  width: 97px;
  height: 36px;
  background: ${p => p.theme.header.logoUrl} no-repeat center;
  background-size: 97px 36px;
  cursor: pointer;
`;

const HeaderBar = ({ history, expand, toggleNavigationMenu, setMenuVisible, menuVisible }) => {
  const fixedMenuProps = useSpring({
    delay: menuVisible ? 200 : 350,
  });
  const dispatch = useDispatch();
  const { hasAnnouncementBanner } = useSelector(state => state.user);

  const updateOnScroll = () => {
    if (window.pageYOffset > 10 && menuVisible) {
      setMenuVisible(false);
    } else if (window.pageYOffset <= 10 && !menuVisible) {
      setMenuVisible(true);
    }
  };

  useEffect(() => {
    window.addEventListener('scroll', updateOnScroll);
    // Remove eventlisteners on unmount
    return () => {
      window.removeEventListener('scroll', updateOnScroll);
    };
  });

  return (
    <>
      <Sticker>
        <Header
          style={fixedMenuProps}
          onMouseEnter={() => window.pageYOffset > 10 && setMenuVisible(true)}
          onMouseLeave={() => window.pageYOffset > 10 && setMenuVisible(false)}
        >
          <OnDesktopAndTablet>
            <LogoContainer>
              <Logo
                onClick={() => {
                  history.push('/');
                }}
              />
            </LogoContainer>
          </OnDesktopAndTablet>
          <OnPhone>
            <HeaderButton icon={expand ? 'times' : 'bars'} onClick={toggleNavigationMenu} />
          </OnPhone>
          <SearchBar />
          <PermissionCheck permissionsList={['ordercreate']}>
            <UploadXmlButton />
          </PermissionCheck>
          {/* eslint-disable no-undef*/}
          <HeaderButton
            icon='bullhorn'
            text='Feedback'
            onClick={() => dispatch(openAnnouncementsSidepanel({ isFeedback: true }))}
            borderLeft
          />
          <SystemMessageButton />
          <UserProfileButton />
        </Header>
      </Sticker>
      {
        hasAnnouncementBanner &&
        <Sticker>
          <Banner />
        </Sticker>
      }
    </>
  );
};
HeaderBar.propTypes = {
  history: PropTypes.object.isRequired,
  expand: PropTypes.bool,
  toggleNavigationMenu: PropTypes.func,
  setMenuVisible: PropTypes.func,
  menuVisible: PropTypes.bool,
};

export default withRouter(HeaderBar);
